<template>
    <div class="flex-col page">
        <div class="flex-col group_3">
            <div class="header">
                <van-dropdown-menu active-color="#6417FF" :close-on-click-overlay="false">
                    <van-dropdown-item class="brandDropdown active-color" title="品牌" ref="brandRef">
                        <template v-for="(brandItemList, name) in brandOptions">
                            <p class="title">{{ name }}</p>
                            <div>
                                <template v-for="item in brandItemList" v-if="brandItemList">
                                    <p class="brandItemList" @click="brandItemClick(item.code)"
                                        style="position:relative;">
                                        <img class="carImg" :src="item.brandLogo" alt="">
                                        <span class="brandName">{{ item.name }}</span>
                                        <!-- <img class="selected" src="https://imgpub1.shouqiev.com/gofunplatform/files/20220801/cByvEyzDVF.png" alt=""> -->
                                        <i v-if="brandSelects.includes(item.code)" class="van-icon van-icon-success"
                                            style="color:rgb(100, 23, 255);position:absolute;right:16px;"></i>
                                    </p>
                                </template>
                            </div>
                        </template>
                        <!-- <div style="height:75px;"></div> -->
                        <div class="dropdown-btn-group">
                            <van-button @click="brandSelects = []">重置</van-button>
                            <van-button type="primary" color="#02d644" @click="brandConfirm" style="font-weight:bold;">
                                完成</van-button>
                        </div>
                    </van-dropdown-item>
                    <van-dropdown-item title="价格" v-model="priceSelect" :options="priceOptions" />

                    <van-dropdown-item title="级别" ref="levelRef">
                        <MulSelectBtnGroup :options="levelOptions" @change="levelChange"></MulSelectBtnGroup>
                    </van-dropdown-item>

                    <van-dropdown-item title="能源" ref="energyRef">
                        <MulSelectBtnGroup :options="energyOptions" @change="energyChange"></MulSelectBtnGroup>
                    </van-dropdown-item>
                </van-dropdown-menu>
            </div>
            <div class="flex-col list" style="padding-top:48px;">
                <div class="justify-between list-item" :key="i" v-for="(item, i) in carlist">
                    <router-link :to="'/salePassat/carDetail/' + item.carSaleId" style="width:100%;">
                        <!-- <keep-alive> -->
                        <CarCard :carDetails="item"></CarCard>
                        <!-- </keep-alive> -->
                    </router-link>
                </div>
                <div v-if="!isLogin" class="notLogin">
                    <img src="https://imgpub1.shouqiev.com/gofunplatform/files/20220819/MQbANJjftv.png" alt="">
                    <p>需要登录后才能看到车辆哦</p>
                    <button @click="goLogin">去登录</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import {
    DropdownMenu,
    DropdownItem,
    Toast,
    Button,
    IndexBar,
    IndexAnchor,
    Checkbox
} from "vant";
import "vant/lib/dropdown-menu/style";
import "vant/lib/dropdown-item/style";
import "vant/lib/toast/style";
import "vant/lib/button/style";
import "vant/lib/switch/style";
import "vant/lib/index-bar/style";
import "vant/lib/index-anchor/style";
import "vant/lib/checkbox/style";

// 获取品牌列表// 获取车型分组列表// 获取售卖车辆列表
import { getBrandList, getCarTypeList, getCarList } from '../api'
import MulSelectBtnGroup from '../_components/MulSelectBtnGroup.vue'
import CarCard from '../_components/CarCard.vue'
import { getImgMixin } from '../getImg_mixin'
import utils from "@/libs/utils/utils";
import jsBridge from '@/libs/jsBridge'

export default {
    components: { DropdownMenu, DropdownItem, IndexBar, IndexAnchor, Checkbox, MulSelectBtnGroup, CarCard, Button },
    data() {
        return {
            isLogin: !!utils.getToken(),
            carlist: [],
            carlist_bak: [],
            priceSelect: "",
            priceOptions: [
                { text: "默认", value: "0" },
                { text: "从高到低", value: "1" },
                { text: "从低到高", value: "2" },
            ],
            brandSelects: [],
            energySelect: [],
            levelSelect: [],
            brandOptions: { "A": [] },
            energyOptions: [{ name: "电车", id: "1" }, { name: "油车", id: "2" }, { name: "混动", id: "3" }],
            levelOptions: [{ name: "", id: "" }],
        };
    },
    mixins: [getImgMixin],
    watch: {
        priceSelect: function (val, oldVal) { // 价格升降
            if (val == 0) {
                this.carlist = [...this.carlist_bak];
                this.removeDropDownActive(1)
            } else if (val == 1) {
                this.carlist = this.carlist.sort((a, b) => (b.presellPrice - a.presellPrice))
                this.setDropDownActive(1)
            } else if (val == 2) {
                this.carlist = this.carlist.sort((a, b) => (a.presellPrice - b.presellPrice))
                this.setDropDownActive(1)
            }
        }
    },
    created() {
        this.init()
    },
    methods: {
        goLogin: function (){
            jsBridge.showLoginView()
        },
        setDropDownActive: function (index) {
            setTimeout(function () {
                document.querySelectorAll('.van-dropdown-menu__title')[index].style.color = '#6417FF'
            }, 300)
        },
        removeDropDownActive: function (index) {
            setTimeout(function () {
                document.querySelectorAll('.van-dropdown-menu__title')[index].style.color = ''
            }, 300)
        },
        init: function () {
            getBrandList().then(res => {
                this.brandOptions = res.result
            })
            getCarTypeList().then(res => {
                this.levelOptions = res.result.map(item => ({ id: item.groupCode, name: item.groupName }))
            })
            this.getCarList()
        },
        getCarList(arg) {
            let params = {};
            if (this.brandSelects.length != 0) {
                params.brandCode = this.brandSelects
            }
            if (this.levelSelect.length != 0) {
                params.level = this.levelSelect
            }
            if (this.energySelect.length != 0) {
                params.energyType = this.energySelect
            }
            getCarList({
                ...params,
                ...arg
            }).then(res => {
                /*
                    id        carSaleId(查看车辆详情传的)
                    车辆图片   carimg
                    车辆名称   name
                    车辆id    carTypeId
                    车辆级别   cartypeLevel
                    排量      cartypePower
                    定金      presellPrice
                    指导价    officialGuidePrice
                */
                this.carlist = res.result.list
                // this.carlist = res.result.list.map(item=>({...item,carImg:this.mixin_imgs[this.getOSSImg(item.carImg)]}))
                /*
                todo
                this.mixin_imgs[this.getOSSImg(item.carImg) 非响应式数据
                需要升级支持响应式数据才能在外层处理
                */
                this.carlist_bak = [...this.carlist]
            },err=>{
                console.log(90999999,err)
                if(err.code == 401 || err.code == 1151){
                    this.isLogin = false;
                }
            })
        },
        brandItemClick: function (item) {
            if (this.brandSelects.includes(item)) {
                this.brandSelects = this.brandSelects.filter(i => item != i)
            } else {
                this.brandSelects.push(item)
            }
        },
        brandConfirm() {
            this.getCarList()
            this.$refs.brandRef.toggle();
            if (this.brandSelects.length == 0) {
                this.removeDropDownActive(0)
            } else {
                this.setDropDownActive(0)
            }

        },
        levelChange(item) {
            this.levelSelect = item
            this.getCarList()
            this.$refs.levelRef.toggle();

            if (item.length == 0) {
                this.removeDropDownActive(2)
            } else {
                this.setDropDownActive(2)
            }
        },
        energyChange(item) {
            this.energySelect = item
            this.getCarList()
            this.$refs.energyRef.toggle();

            if (item.length == 0) {
                this.removeDropDownActive(3)
            } else {
                this.setDropDownActive(3)
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '../common.css';
.page {
    .notLogin{
        display: flex;
        flex-direction: column;
        img {
            width:355px;
            height:202px;
            margin: 250px auto 0;
        }
        p{
           font-family: PingFangSC-Regular;
            font-size: 15px;
            color: #9DAFBD;
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
            text-align: center;
            margin-top:60px;
        }
        button{
            width:328px;
            height:84px;
            line-height: 84px;
            margin:0 auto;
            background: #02D644;
            border-radius: 42px;
            margin-top:32px;
            color:white;
            font-size:32px;
        }
    }
    padding-top: 0.027rem;
    background-color: #f5f5f5;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;

    .group_3 {
        .list {
            margin-bottom: -0.21rem;
            padding: 166px 0.21rem 0;

            .list-item {
                // padding: 0.32rem 0.32rem 0.29rem;
                background-color: #ffffff;
                border-radius: 0.21rem;

                &:not(:first-of-type) {
                    margin-top: 0.21rem;
                }
            }
        }
    }
}



.header {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 80px;
    background: white;

    .brandDropdown {
        color: red;

        /deep/ .van-dropdown-item__content {
            max-height: 100%;
        }

        .title {
            background: #F5F5F5;
            height: 66px;
            line-height: 66px;
            padding-left: 32px;
            color:#333;
        }

        .brandItemList {
            height: 112px;
            line-height: 112px;
            border-bottom: solid #E0E0E0 1px;
            // border-bottom:solid #F5F5F5 1px;
            display: flex;
            align-items: center;
            padding-left: 32px;

            .carImg {
                width: 48px;
                height: 48px;
            }

            .brandName {
                font-family: PingFangSC-Regular;
                font-size: 28px;
                color: #333333;
                font-weight: 400;
                margin: 0 16px;
            }

            img.selected {
                width: 32px;
                height: 32px;
            }

        }

        .brandItemList:last-of-type {
            border: none;
        }

        .dropdown-btn-group {
            display: flex;
            justify-content: space-between;
            position: fixed;
            left: 0;
            right: 0;
            top: calc(50% + 40px);

            margin: 0;
            padding:0 40px;
            height: 140px;
            line-height: 140px;
            border-top: solid #E0E0E0 1px;
            background: white;

            button {
                margin-top: 24px;
                width: 326px;
                height: 84px;
                border-radius: 42px;
            }
        }

    }

    /deep/ .van-dropdown-menu__bar {
        border-bottom: solid #E0E0E0 0.5px;
        box-shadow: none;
        padding: 0 16px;
        margin-top: 8px;
        height: 72px;
        line-height: 72px;
    }
    /deep/ .van-popup {
        // border:solid red 1px;
        height:calc(50% + 140px);
        padding-bottom:140px;
    }
}

/deep/ .van-icon-success:before {
    width: 32px;
    height: 32px;
    font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// carList.vue?0cbcfc27